import {Service} from '@/request/http.js'

// 注册
export function emailRegister (data) {
  return Service({
    url: '/api/emailRegister',
    method: 'post',
    params: data
  })
}

// 登录
export function signIn (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 微信登录.
export function weiXinSignIn (data) {
  return Service({
    url: '/api/weixinLogin',
    method: 'post',
    params: data
  })
}

// 微信直接登录.
export function weiXinDirectLogin (data) {
  return Service({
    url: '/api/weixinLogin',
    method: 'post',
    params: data
  })
}

// 邮箱验证
export function emailVerify (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 忘记密码
export function forgetPass (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 邮箱确认
export function emailRetype (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 忘记密码修改密码
export function emailChangePassword (data) {
  return Service({
    url: '/api/signIn',
    method: 'post',
    params: data
  })
}

// 三方授权登录：wechat、google、facebook、apple.
export function authorizedLogin (data) {
  return Service({
    url: '/api/authorizedLogin',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/login.js